// extracted by mini-css-extract-plugin
export default {"initialPageL2":"InitialPageL2_initialPageL2__VO0LM","pieGraph":"InitialPageL2_pieGraph__P2gBk"};